var map = {
	"./1-nationalInsurance.png": [
		8414,
		8414
	],
	"./10-edelweissLifeTokio.png": [
		72223,
		2223
	],
	"./11-exideLifeInsurance.png": [
		54063,
		4063
	],
	"./12-futureGenerali.png": [
		19726,
		9726
	],
	"./13-hdfcERGO.png": [
		34691,
		4691
	],
	"./14-bajajAllianz.png": [
		44991,
		4991
	],
	"./15-iciciLombard.png": [
		12001,
		2001
	],
	"./16-iciciPrudential.png": [
		3503,
		3503
	],
	"./17-iffcoTOKIO.png": [
		25147,
		5147
	],
	"./18-kotakGeneralInsuance.png": [
		83673,
		3673
	],
	"./19-kotakLifeInsurance.png": [
		44402,
		4402
	],
	"./2-hdfcLife.png": [
		29690,
		9690
	],
	"./20-liberty.png": [
		5410,
		5410
	],
	"./21-LIC.png": [
		98590,
		8590
	],
	"./22-magmaHDI.png": [
		2520,
		2520
	],
	"./23-manipalCigna.png": [
		45867,
		5867
	],
	"./24-maxLife.png": [
		94594,
		4594
	],
	"./25-adityaBirla.png": [
		88897,
		8897
	],
	"./26-niva.png": [
		42421,
		2421
	],
	"./27-orientalInsurance.png": [
		19500,
		9500
	],
	"./28-pnbMetLife.png": [
		11326,
		1326
	],
	"./29-rahejaQBE.png": [
		68571,
		8571
	],
	"./3-BajajAllianzGeneralInsurance.png": [
		96265,
		6265
	],
	"./30-relianceGeneralInsurance.png": [
		62512,
		2512
	],
	"./31-relianceNipponLifeInsurance.png": [
		88963,
		8963
	],
	"./32-royalSundaram.png": [
		7776,
		7776
	],
	"./33-sbiGeneral.png": [
		48311,
		8311
	],
	"./34-sbiLife.png": [
		27582,
		7582
	],
	"./35-shriramGeneralInsurance.png": [
		75258,
		5258
	],
	"./36-shriramlifeInsurance.png": [
		23466,
		3466
	],
	"./37-starHealthInsurance.png": [
		98146,
		8146
	],
	"./38-tataAIG.png": [
		73355,
		3355
	],
	"./39-theNewIndiaAssurance.png": [
		7665,
		7665
	],
	"./4-bhartiAXA.png": [
		37353,
		7353
	],
	"./40-unitedIndia.png": [
		1984,
		1984
	],
	"./41-universalSompoGeneralInsurance.png": [
		76879,
		6879
	],
	"./42-tataLife.png": [
		54815,
		4815
	],
	"./43-bajajLife.png": [
		93664,
		3664
	],
	"./5-canaraHSBC.png": [
		2767,
		2767
	],
	"./6-careHealth.png": [
		17277,
		7277
	],
	"./7-cholaMS.png": [
		46449,
		6449
	],
	"./8-digit.png": [
		44477,
		4477
	],
	"./9-edelweiss.png": [
		85068,
		5068
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 93529;
module.exports = webpackAsyncContext;